export const CorrectCircleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="9" cy="9" r="9" fill="currentColor" />
      <path d="M4.33301 8.41536L8.41634 12.207L13.958 5.20703" stroke="white" strokeWidth="2.5" />
    </svg>
  );
};
